export const ENGLISH_IQ_STORED_SESSION_VERSION = 1;
